import { useContext, useEffect } from 'react';
import { ExecuteStepInput } from 'sr-types/lib/workflow/v1/graphql';
import { FormContext, FormContextType } from '../../../form/FormContext';

export interface ApprovalActionInputValidityObserverProps {
    onApprovalActionDataValidityChange: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function ApprovalActionInputValidityObserver({
    onApprovalActionDataValidityChange
}: ApprovalActionInputValidityObserverProps) {
    const { validation: { isValid = false } = {} } = useContext<FormContextType<ExecuteStepInput>>(FormContext);

    useEffect(() => {
        onApprovalActionDataValidityChange((prevIsValid) => {
            if (prevIsValid === isValid) {
                return prevIsValid;
            }

            return isValid;
        });
    }, [isValid, onApprovalActionDataValidityChange]);

    return null;
}
